import React from "react";
import { withRouter } from "react-router-dom";

import AuthUserContext from "../Auth/AuthUserContext";
import { auth } from "../../firebase/index";
import * as routes from "../../routes/app";

const withAuthorization = authCondition => Component => {
  class WithAuthorization extends React.Component {
    componentDidMount() {
      auth.onAuthStateChanged(authUser => {
        if (!authCondition(authUser)) {
          this.props.history.push(routes.Login);
        }
        
      });
    }
    render() {
      return (
        <AuthUserContext.Consumer>
          {authUser => (authUser ? <Component /> : null)}
        </AuthUserContext.Consumer>
      );
    }
  }
  return withRouter(WithAuthorization);
};

export default withAuthorization;
